import { z } from 'zod';

import { RegisterCustomerVehicleBodySchema } from '../vehicle/register-customer-vehicle.schemas.js';

import { AddCustomerRoleBodySchema } from './add-customer-role.schemas.js';

export const CompletePartyRegistrationBodySchema = AddCustomerRoleBodySchema.extend({
  marketingConsent: z.boolean().optional(),
  vehicles: z.array(RegisterCustomerVehicleBodySchema).optional(),
});

export type CompletePartyRegistrationBody = z.infer<typeof CompletePartyRegistrationBodySchema>;

export const CompletePartyRegistrationResponseSchema = z.object({
  partyId: z.uuid(),
  customerRoleId: z.uuid(),
});

export type CompletePartyRegistrationResponse = z.infer<
  typeof CompletePartyRegistrationResponseSchema
>;

export const DiscardPartyDraftResponseSchema = z.object({
  partyId: z.uuid(),
});

export type DiscardPartyDraftResponse = z.infer<typeof DiscardPartyDraftResponseSchema>;
